import { useSpring } from '@react-spring/web';
import {
  UseAnimatedNumberOptions,
  UseAnimatedNumberResult
} from './use-animated-number-types';

export default function useAnimatedNumber(
  value: number,
  format: (n: number) => string,
  { immediate = false }: UseAnimatedNumberOptions = {}
): UseAnimatedNumberResult {
  const { val } = useSpring({
    val: value,
    immediate,
    config: { tension: 170, friction: 26 }
  });

  return {
    display: val.to((v) => format(Math.round(v)))
  };
}
